module.exports = __webpack_public_path__ + "static/vista-6-b43a6e4829debc1dd7e4e6beddfde114.png";